<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="props.color"
      d="M7.43999 10.8H8.55999V7.43999H7.43999V10.8ZM7.99999 6.31999C8.15866 6.31999 8.29166 6.26633 8.39899 6.15899C8.50633 6.05166 8.55999 5.91866 8.55999 5.75999C8.55999 5.60133 8.50633 5.46833 8.39899 5.36099C8.29166 5.25366 8.15866 5.19999 7.99999 5.19999C7.84133 5.19999 7.70833 5.25366 7.60099 5.36099C7.49366 5.46833 7.43999 5.60133 7.43999 5.75999C7.43999 5.91866 7.49366 6.05166 7.60099 6.15899C7.70833 6.26633 7.84133 6.31999 7.99999 6.31999ZM7.99999 13.6C7.22533 13.6 6.49733 13.453 5.81599 13.159C5.13466 12.865 4.54199 12.466 4.03799 11.962C3.53399 11.458 3.13499 10.8653 2.84099 10.184C2.54699 9.50266 2.39999 8.77466 2.39999 7.99999C2.39999 7.22533 2.54699 6.49733 2.84099 5.81599C3.13499 5.13466 3.53399 4.54199 4.03799 4.03799C4.54199 3.53399 5.13466 3.13499 5.81599 2.84099C6.49733 2.54699 7.22533 2.39999 7.99999 2.39999C8.77466 2.39999 9.50266 2.54699 10.184 2.84099C10.8653 3.13499 11.458 3.53399 11.962 4.03799C12.466 4.54199 12.865 5.13466 13.159 5.81599C13.453 6.49733 13.6 7.22533 13.6 7.99999C13.6 8.77466 13.453 9.50266 13.159 10.184C12.865 10.8653 12.466 11.458 11.962 11.962C11.458 12.466 10.8653 12.865 10.184 13.159C9.50266 13.453 8.77466 13.6 7.99999 13.6ZM7.99999 12.48C9.25066 12.48 10.31 12.046 11.178 11.178C12.046 10.31 12.48 9.25066 12.48 7.99999C12.48 6.74933 12.046 5.68999 11.178 4.82199C10.31 3.95399 9.25066 3.51999 7.99999 3.51999C6.74933 3.51999 5.68999 3.95399 4.82199 4.82199C3.95399 5.68999 3.51999 6.74933 3.51999 7.99999C3.51999 9.25066 3.95399 10.31 4.82199 11.178C5.68999 12.046 6.74933 12.48 7.99999 12.48Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
  width?: string | number;
  height?: string | number;
}

const props = withDefaults(defineProps<icon>(), {
  color: 'black',
  width: '16',
  height: '16',
});
</script>
